import { render } from "./RenewableEnergy.vue?vue&type=template&id=224203be"
import script from "./RenewableEnergy.vue?vue&type=script&lang=js"
export * from "./RenewableEnergy.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__